const urlParsed = new URL(window.location);
const splitHost = urlParsed.host.split('.');
const instanceKeywords = ['tesla', 'prod'];
export default () => {
  let status = false;
  splitHost.forEach(word => {
    if (instanceKeywords.includes(word)) {
      status = true;
    }
  });
  return status;
};
